export default "__VITE_ASSET__DxsTY_Ty__";